import { defineComponent as _defineComponent } from 'vue'

  import { EstateMapInterface } from "@/types/EstateMapInterface";
  import { getStageStatusClass } from "@/helpers/status";
  import { StageStatus } from "@/enums/StageStatus";
  import { UserRoles } from "@/enums/UserRoles";
  import { LotMapInterface } from "@/types/LotMapInterface";
  import { LotStatus } from "@/enums/LotStatus";
  import { getId } from "@/helpers/lot/homeAndLand";

  interface BuilderMarkerColors {
    color: string;
    colorB?: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'StageSvgMap',
  props: {
    map: {},
    lots: {},
    zoom: {},
    getTooltipText: { type: Function },
    getItemWrClasses: { type: Function },
    getItemPathClasses: { type: Function },
    getItemStatusPathClasses: { type: Function },
    builderColorsById: {}
  },
  emits: ["onLotHover", "onLotLeave", "onLotClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const onLotHover = (id: string) => {
    emits("onLotHover", id);
  };

  const onLotLeave = () => {
    emits("onLotLeave");
  };

  const onLotClick = (stage: LotMapInterface) => {
    emits("onLotClick", stage);
  };

  const shouldShowHouseMarker = (lot: LotMapInterface) => {
    return Boolean(lot.houseMarker && lot.lotId?.isBuildersEnabled);
  };

  const getHouseMarkerBox = (lot: LotMapInterface) => {
    const marker = lot.houseMarker as NonNullable<
      LotMapInterface["houseMarker"]
    >;

    const minSize = 24;
    const size = Math.max(marker.width, marker.height, minSize) * 0.8;

    return {
      x: marker.x + marker.width / 2 - size / 2,
      y: marker.y + marker.height / 2 - size / 2,
      size,
    };
  };

  const getHouseMarkerTransform = (lot: LotMapInterface) => {
    const markerBox = getHouseMarkerBox(lot);

    return `translate(${markerBox.x} ${markerBox.y}) scale(${
      markerBox.size / 24
    })`;
  };

  const getPrimaryBuilderId = (lot: LotMapInterface) => {
    return getId(lot.lotId?.builders?.[0]?.builderId);
  };

  const getHouseMarkerColors = (lot: LotMapInterface) => {
    const builderId = getPrimaryBuilderId(lot);
    const builderColors = builderId
      ? props.builderColorsById[builderId]
      : undefined;

    return {
      color: builderColors?.color || "#1f8fdd",
      colorB: builderColors?.colorB || builderColors?.color || "#111827",
    };
  };

const __returned__ = { props, emits, onLotHover, onLotLeave, onLotClick, shouldShowHouseMarker, getHouseMarkerBox, getHouseMarkerTransform, getPrimaryBuilderId, getHouseMarkerColors, get EstateMapInterface() { return EstateMapInterface }, get getStageStatusClass() { return getStageStatusClass }, get StageStatus() { return StageStatus }, get UserRoles() { return UserRoles }, get LotMapInterface() { return LotMapInterface }, get LotStatus() { return LotStatus }, get getId() { return getId } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})